import { struct } from 'io-ts/Decoder';

import { Id as Level } from '../../../../ai/floor-level/Id';

export const Request = struct({
	level: Level,
});
